export enum CardColors {
  gray = 'gray',
  grayWhite = 'grayWhite',
  yellow = 'yellow',
  red = 'red',
  blue = 'blue',
  blueWhite = 'blueWhite',
  green = 'green',
  intense_green = 'intense_green',
}

export interface ICardColorSchemaLists {
  secondary: string
  primary: string
}

export const cardColorSchemaList = {
  [CardColors.blueWhite]: {
    secondary: 'whiteAlpha.900',
    primary: 'blue.500',
  },
  [CardColors.blue]: {
    secondary: 'blue.100',
    primary: 'blue.500',
  },
  [CardColors.red]: {
    secondary: 'red.100',
    primary: 'red.500',
  },
  [CardColors.yellow]: {
    secondary: 'orange.100',
    primary: 'yellow.500',
  },
  [CardColors.grayWhite]: {
    secondary: 'whiteAlpha.900',
    primary: 'gray.800',
  },
  [CardColors.gray]: {
    secondary: 'gray.100',
    primary: 'gray.600',
  },
  [CardColors.green]: {
    secondary: 'green.100',
    primary: 'green.500',
  },
  [CardColors.intense_green]: {
    secondary: 'green.200',
    primary: 'green.500',
  },
}

export const productColorSchemaList = {
  [CardColors.blueWhite]: {
    secondary: 'whiteAlpha.900',
    primary: 'blue.500',
  },
  [CardColors.blue]: {
    secondary: 'blue.200',
    primary: 'blue.500',
  },
  [CardColors.red]: {
    secondary: 'red.200',
    primary: 'red.500',
  },
  [CardColors.yellow]: {
    secondary: 'orange.200',
    primary: 'yellow.500',
  },
  [CardColors.grayWhite]: {
    secondary: 'whiteAlpha.900',
    primary: 'gray.800',
  },
  [CardColors.gray]: {
    secondary: 'gray.200',
    primary: 'gray.600',
  },
  [CardColors.green]: {
    secondary: 'green.200',
    primary: 'green.500',
  },
}
